import {connect} from "react-redux";
import OpportunityNewActivity from './newActivity'
import {bindActionCreators} from "redux";
import {dropdownData} from "../../../service/Account/action";
import {newActivity} from "../../../service/Activity/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    saveNewActivity:state.Activity.saveNewActivity,
    dropdownValue:state.Dropdown.dropdownValue,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            documentUploadUrlPublic,
            newActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityNewActivity);
